<!-- 谈判人接单列表/谈判人去接单页面都用到这个组件 -->
<template>
  <div class="tpr_follow_list_item">
    <div class="title bb1g">
      <!-- 谈判人去跟单页面-右上角标签 -->
      <!-- 发布时间： -->
      <template v-if="type === 'tprGetFollow'">
        {{ $t("devUpdates.published") }}{{ item.createTime }}
        <!-- clueType：1 货源信息 0 求购信息 -->
        <!-- 货源信息 -->
        <div class="custom_tag tag_yellow" v-if="item.clueType == 1">
          {{ $t("personalOrderList.supplyInfo") }}
        </div>
        <!-- 求购信息 -->
        <div class="custom_tag tag_green" v-else>
          {{ $t("business.buyRequestInfo") }}
        </div>
      </template>

      <!-- 谈判人跟单页面-右上角标签 -->
      <!-- 接单时间： -->
      <!-- 货源线索谈判人 -->
      <template v-else>
        {{ $t("workflowFeedback.acceptedAt")
        }}{{ $formatTime(item.followTime) }}
        <div
          class="custom_tag tag_blue"
          v-if="item.type === 10 && item.model === 1 && item.identity === 10"
        >
          {{ $t("workflowFeedback.supplyClueNegotiator") }}
        </div>
        <!-- 求购线索谈判人 -->
        <div
          class="custom_tag tag_blue"
          v-if="item.type === 10 && item.model === 2 && item.identity === 10"
        >
          {{ $t("workflowFeedback.demandClueNegotiator") }}
        </div>

        <!-- 货源商品谈判人 -->
        <div
          class="custom_tag tag_blue"
          v-if="item.type === 20 && item.model === 1 && item.identity === 10"
        >
          {{ $t("workflowFeedback.supplyGoodsNegotiator") }}
        </div>

        <!-- 购买商品谈判人 -->
        <div
          class="custom_tag tag_blue"
          v-if="item.type === 20 && item.model === 2 && item.identity === 10"
        >
          {{ $t("workflowFeedback.purchaseGoodsNegotiator") }}
        </div>

        <!-- 交易采购谈判人 -->
        <div
          class="custom_tag tag_blue"
          v-if="item.type === 30 && item.model === 1 && item.identity === 10"
        >
          {{ $t("workflowFeedback.purchaseTradeNegotiator") }}
        </div>
        <!-- 交易销售谈判人 -->
        <div
          class="custom_tag tag_blue"
          v-if="item.type === 30 && item.model === 2 && item.identity === 10"
        >
          {{ $t("workflowFeedback.salesTradeNegotiator") }}
        </div>
      </template>
    </div>

    <div class="goods_box bb1g">
      <van-image class="goods_img" radius="8px" :src="item.goodsImage" />

      <div class="goods_content">
        <div class="font16">{{ item.goodsName }}</div>
        <div class="goods_info">
          <!-- 美元 -->
          <!-- 元 -->
          <div>
            <!-- 信息价格 -->
            <span class="label">{{
              $t("workflowFeedback.informationPrice")
            }}</span
            >{{ $formatPrice(item.goodsPrice)
            }}{{
              item.goodsPriceUnit == 10
                ? $t("marketComponents.usDollar")
                : $t("pcPublish.yuan")
            }}
          </div>
          <div>
            <!-- 数量 -->
            <span class="label">{{ $t("pcBrand.quantity") }}</span>
            {{ item.goodsQuantity }}
            {{ item.goodsUnit }}
          </div>
        </div>
      </div>
    </div>

    <div class="info bb1g" v-if="item.originalGoodsPrice">
      <!-- 美元 -->
      <!-- 元 -->
      <div>
        <!-- 商品原价： -->
        <span class="label">{{
          $t("workflowFeedback.originalPricePrefix")
        }}</span
        >{{ item.originalGoodsPrice
        }}{{
          item.originalGoodsPriceUnit == 10
            ? $t("marketComponents.usDollar")
            : $t("pcPublish.yuan")
        }}
      </div>
      <a
        :href="`tel:${item.ownerMobile.replace(/\D/g, '')}`"
        class="flex tel-link cblue gap_4"
      >
        <van-icon name="phone-o" size="16px" />
        {{ formatMobile(item.ownerMobile) }}</a
      >
    </div>
    <div class="info bb1g">
      <div>
        <!-- 买方信息提供人： -->
        <span class="label">{{
          $t("workflowFeedback.buyerProviderPrefix")
        }}</span
        >{{ item.contactName }}
      </div>
      <a
        :href="`tel:${item.contactMobile.replace(/\D/g, '')}`"
        class="flex tel-link cblue gap_4"
      >
        <van-icon name="phone-o" size="16px" />
        {{ formatMobile(item.contactMobile) }}</a
      >
    </div>

    <!--按钮区域 -->
    <div class="button_box">
      <!-- 谈判人去跟单页面-抢单按钮 -->
      <template v-if="type === 'tprGetFollow'">
        <!-- 屏蔽该信息 -->
        <van-button size="small" @click="blockTprGetFollow(item)">{{
          $t("workflowFeedback.blockInformation")
        }}</van-button>
        <!-- 抢单 -->
        <van-button
          type="info"
          size="small"
          @click="handlerTprGetFollow(item)"
          >{{ $t("workflowFeedback.claimOrder") }}</van-button
        >
      </template>

      <!--   谈判人跟单页面-按钮 -->
      <template v-else>
        <!-- 查看详情 -->
        <van-button
          size="small"
          v-if="!(item.type === 10 && item.status === 1)"
          @click="viewDetail(item)"
          >{{ $t("buyOrders.viewDetails") }}</van-button
        >
        <!-- 发布货源 -->
        <van-button
          v-if="item.type === 10 && item.status === 1"
          type="info"
          size="small"
          @click="
            $router.push({
              path: '/source/publishGoods',
              query: { id: item.clueId },
            })
          "
          >{{ $t("sourcePublish.postSupply") }}</van-button
        >
        <!-- 修改购买意向单 -->
        <van-button
          v-if="item.type === 30 && item.status === 1 && item.model === 2"
          type="info"
          size="small"
          @click="
            $router.push({
              path: '/follow/tpr/editPreOrder',
              query: { orderId: item.preOrderId, followId: item.id },
            })
          "
          >{{ $t("preOrder.edit") }}</van-button
        >
        <!-- 确认意向单 -->
        <van-button
          v-if="item.type === 30 && item.status === 1 && item.model === 1"
          type="info"
          size="small"
          @click="
            $router.push({
              path: '/follow/tpr/confirmPreOrder',
              query: { orderId: item.preOrderId, followId: item.id },
            })
          "
          >{{ $t("preOrder.confirm") }}</van-button
        >
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  methods: {
    // 查看谈判人跟单详情
    viewDetail(item) {
      this.$router.push("/follow/tprFollowDetail/" + item.id);
    },

    // 抢单
    handlerTprGetFollow(item) {
      this.$emit("tpr-get-follow", item);
    },
    // 屏蔽该信息
    blockTprGetFollow(item) {
      this.$emit("tpr-block-follow", item);
    },
    formatMobile(mobile) {
      // 严格判空 + 格式校验
      if (!mobile || isNaN(Number(mobile)) || mobile.length !== 11) {
        return ""; // 空值/非11位数字直接返回空
      }
      // 格式化
      return mobile.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    },
  },
};
</script>

<style lang="less" scoped>
.tpr_follow_list_item {
  font-size: 14px;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    font-size: 13px;
    color: rgba(59, 59, 59, 0.8);
  }

  .goods_box {
    display: flex;
    padding: 18px 0;
    .goods_img {
      width: 22%;
      // 高度和宽度保持一致
      aspect-ratio: 1/1;
      margin-right: 18px;
    }
    .goods_content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .font16 {
        font-size: 16px;
        font-weight: 500;
      }
      .goods_info {
        display: flex;
        align-items: center;
        gap: 16px;
      }
    }
  }

  //信息展示-电话
  .info {
    padding: 12px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  // 标题名称
  .label {
    margin-right: 8px;
    color: #999;
    display: inline-block;
  }

  .button_box {
    padding-top: 18px;
    display: flex;
    align-content: center;
    justify-content: flex-end;
    gap: 10px;
    .van-button {
      border-radius: 8px !important;
      font-size: 14px !important;
      padding: 7px 15px !important;
    }
  }
}
</style>
